import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import * as moment from "moment";
import Calendar from "react-calendar";
import { Popup } from "../../../library/popup";
import { Label } from "../../../library/label";
import TabSelector from "../../../library/tab-selector";
import { useSelector, useDispatch } from "react-redux";
import {
  changeOverviewFilter,
  changeOverviewModal,
} from "../../../../redux/actions/overview";
import { Input } from "../../../library/input";
import { SolidButton, TransparentButton } from "../../../library/button";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const rangeType = useSelector((state) => state.overview.activeRangeType);

  const modalState = useSelector(
    (state) => state.overview.showModals.rangeModal
  );

  const [customizedStartDate, setCustomizedStartDate] = useState(undefined);
  const [customizedEndDate, setCustomizedEndDate] = useState(undefined);

  const selectionTabs = [
    {
      key: "datefrom",
      title: "Dato fra",
      content: (
        <Calendar
          value={customizedStartDate ? customizedStartDate : undefined}
          onChange={(e) => handleCustomizedStartDate(e)}
        />
      ),
    },
    {
      key: "dateto",
      title: "Dato til",
      content: (
        <Calendar
          value={customizedEndDate ? customizedEndDate : undefined}
          onChange={(e) => handleCustomizedEndDate(e)}
        />
      ),
    },
  ];

  const handleClose = () => {
    dispatch(changeOverviewModal({ rangeModal: false }));
  };

  const handleCustomizedStartDate = (date) => {
    setCustomizedStartDate(date);
  };

  const handleCustomizedEndDate = (date) => {
    setCustomizedEndDate(date);
  };

  const clickNewRange = () => {
    const start = moment(customizedStartDate)
      .set({ hour: 0, minute: 0, second: 0 })
      .unix();
    const end = moment(customizedEndDate)
      .set({ hour: 23, minute: 59, second: 59 })
      .unix();

    switch (rangeType) {
      case "responses":
        dispatch(
          changeOverviewFilter({
            type: "response",
            filter: { name: "custom", range: { start: start, end: end } },
          })
        );
        dispatch(changeOverviewModal({ rangeModal: false }));
        break;
      case "clients":
        dispatch(
          changeOverviewFilter({
            type: "clients",
            filter: { name: "custom", range: { start: start, end: end } },
          })
        );
        dispatch(changeOverviewModal({ rangeModal: false }));
        break;
      case "sales":
        dispatch(
          changeOverviewFilter({
            type: "sales",
            filter: { name: "custom", range: { start: start, end: end } },
          })
        );
        dispatch(changeOverviewModal({ rangeModal: false }));
        break;
      case "scoreboard":
        dispatch(
          changeOverviewFilter({
            type: "scoreboard",
            filter: { name: "custom", range: { start: start, end: end } },
          })
        );
        dispatch(changeOverviewModal({ rangeModal: false }));
        break;
      default:
        break;
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Egendefinert tidsramme"
      buttons={[
        <TransparentButton
          title="Avbryt"
          ype="button"
          data-dismiss="modal"
          onClick={handleClose}
        />,
        <SolidButton
          title="Sett tidsramme"
          color="blue"
          onClick={() => clickNewRange()}
          type="button"
        />,
      ]}
    >
      <div className="assign-range-modal-content">
        <TabSelector defaultValue="datefrom" items={selectionTabs} />
        <div className="range-overview-container">
          <Row className="range-row">
            <Col md={6}>
              <Label version={1} weight="bold">
                Dato fra
              </Label>
              <Input
                disabled
                value={moment(customizedStartDate)
                  .format("YYYY-MM-DD")
                  .toString()}
                contentEditable={false}
                type="date"
              />
            </Col>
            <Col md={6}>
              <Label version={1} weight="bold">
                Dato til
              </Label>
              <Input
                disabled
                value={moment(customizedEndDate)
                  .format("YYYY-MM-DD")
                  .toString()}
                contentEditable={false}
                type="date"
              />
            </Col>
          </Row>
        </div>
      </div>
    </Popup>
  );
};

export default Index;
